









import CloseIcon from "../../../../assets/svg/mini-close.svg";
import {Component, Vue} from "vue-property-decorator";

@Component({
    name: "MediaLibraryHeader",
    components: { CloseIcon }
})
export default  class MediaLibraryHeader extends Vue {

}
